import { render, staticRenderFns } from "./veStuGraduationMy.vue?vue&type=template&id=1208c9ed&scoped=true"
import script from "./veStuGraduationMy.vue?vue&type=script&lang=js"
export * from "./veStuGraduationMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208c9ed",
  null
  
)

export default component.exports